(function () {
    'use strict';

    angular
        .module('NaviaqWebApp')
        .factory('dxDataGridFactory', dxDataGridFactory);

    function dxDataGridFactory(
        $translate
    ) {

        return {
            createGridInstance
        };

        function createGridInstance(
            gridContainerElement,
            gridOptions = {
                name: null,
                columns: [],
                dataSource: null,
                multiSelectActions: [],
                getMultiSelectVisibilityFn: () => true,
                toolbarActions: []
            }
        ){
            let dataGridInstance = 
                dxjQuery(gridContainerElement)
                .dxDataGrid({
                    dataSource: gridOptions.dataSource,
                    export: {
                        enabled: true,
                        formats: ['xlsx', 'pdf'],
                        texts: {
                            exportAll: `${$translate.instant("EXPORT_TO")} {0}`
                        }
                    },
                    onExporting: function (e) {
                        if (e.format === 'xlsx') {
                            const workbook = new ExcelJS.Workbook();
                            const worksheet = workbook.addWorksheet(`${gridOptions.name}`);
                            DevExpress.excelExporter.exportDataGrid({
                                component: e.component,
                                worksheet,
                                autoFilterEnabled: true,
                            }).then(() => {
                                workbook.xlsx.writeBuffer().then((buffer) => {
                                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${gridOptions.name}_export.xlsx`);
                                });
                            });
                        } 
                        else if (e.format === 'pdf') {
                            const doc = new jspdf.jsPDF();
                            DevExpress.pdfExporter.exportDataGrid({
                                jsPDFDocument: doc,
                                component: e.component,
                            }).then(() => {
                                doc.save(`${gridOptions.name}_export.pdf`);
                            });
                        }
                    },
                    remoteOperations: false,
                    height: '100%',
                    width: '100%',
                    allowColumnResizing: true,
                    allowColumnReordering: true,
                    columnHidingEnabled: false,
                    customizeColumns: function (columns) {
                        columns.forEach(col => {
                            // Default column group headers to only show value
                            col.groupCellTemplate = function(element, options) {
                                element.text(options.value);
                            }
                        })
                    },
                    columnChooser: {
                        enabled: true,
                        mode: "select",
                        position: { 
                            my: "top right",
                            at: "right bottom",
                            of: ".dx-datagrid-column-chooser-button"
                        },
                        height: "50vh"
                    },
                    showBorders: true,
                    columnResizeMode: "widget",
                    columnMinWidth: 40,
                    headerFilter: {
                        visible: true,
                        allowSelectAll: true,
                        search: {
                            enabled: true,
                            timeout: 700,
                            mode: "contains",
                            allowSelectAll: true
                        },
                        selectAllMode: "allPages"
                    },
                    groupPanel: {
                        visible: true,
                    },
                    grouping: {
                        autoExpandAll: false,
                        expandMode: 'rowClick'
                    },
                    searchPanel: {
                        visible: true,
                    },
                    hoverStateEnabled: true,
                    selection: {
                        mode: "multiple",
                        allowSelectAll: true,
                        showCheckboxesMode: "always"
                    },
                    sorting: {
                        mode: "multiple"
                    },
                    rowAlternationEnabled: true,
                    scrolling: {
                        rowRenderingMode: "virtual",
                        preloadEnabled: false,
                        mode: "virtual",
                        useNative: true
                    },
                    paging: {
                        pageSize: 100
                    },
                    stateStoring: {
                        enabled: true,
                        type: "custom",
                        storageKey: `state_${gridOptions.name}`,
                        customSave: function(state) {
                            // Only save column settings
                            delete state.filterPanel;
                            delete state.filterValue;
                            delete state.filterSyncEnabled;
                            delete state.searchText;
        
                            if (state.columns) {
                                state.columns.forEach(col => {
                                    delete col.filterValues;
                                    delete col.selectedFilterOperation;
                                    delete col.sortOrder;
                                    delete col.sortIndex; 
                                });
                            }
                            
                            const stateToSave = {
                                columns: state.columns
                            };
        
                            localStorage.setItem(this.storageKey, JSON.stringify(stateToSave));
                        },
                        customLoad: function() {
                            const savedState = localStorage.getItem(this.storageKey);
                            return savedState ? JSON.parse(savedState) : {};
                        }
                    },
                    columns: gridOptions.columns
                }).dxDataGrid("instance");
                
            if (gridOptions.multiSelectActions.length > 0) {
                
                let multiSelectPopupPosition = {
                    my: 'bottom center',
                    at: 'bottom center',
                    of: gridContainerElement,
                    offset: { x: 0, y: -40 }
                };
                
                dataGridInstance.multiSelectPopup = 
                dxjQuery(`<div id="${gridOptions.name}-multi-select-popup" class="grid-multi-select-popup"></div>`)
                .appendTo(gridContainerElement)
                .dxPopup({
                    animation: {
                        show: {
                            type: "slide",
                            duration: 160,
                            from: { 
                                position: { 
                                    my: "top center", 
                                    at: "bottom center", 
                                    of: gridContainerElement
                                }, 
                                opacity: 0 
                            },
                            to: { 
                                position: multiSelectPopupPosition, 
                                opacity: 1 
                            },
                            easing: "ease-out"
                        },
                        hide: {
                            type: "slide",
                            duration: 160,
                            from: { 
                                position: multiSelectPopupPosition, 
                                opacity: 1 
                            },
                            to: { 
                                position: { 
                                    my: "top center", 
                                    at: "bottom center", 
                                    of: gridContainerElement 
                                }, opacity: 0 
                            },
                            easing: "ease-in"
                        }
                    },
                    visible: false,
                    showTitle: false,
                    shading: false,
                    height: 'auto',
                    width: 'auto',
                    minWidth: '33%',
                    position: multiSelectPopupPosition,
                    onHiding: function (e) {
                        dataGridInstance.clearSelection();
                    },
                    contentTemplate: function() {
                        return dxjQuery("<div>").dxToolbar({
                            items: [
                                // Display number currently selected
                                {
                                    location: "before",
                                    text: `0 ${$translate.instant('G_SELECTED')}`,
                                    cssClass: "selected-count",
                                    name: "selectionCount"
                                },
                                ... gridOptions.multiSelectActions,
                                // Close popup and deselect selected rows
                                {
                                    location: "after",
                                    widget: "dxButton",
                                    options: {
                                        icon: "close",
                                        hint: $translate.instant('G_UNSELECT_ALL'),
                                        onClick: function() {
                                            dataGridInstance.multiSelectPopup.hide();
                                        }
                                    }
                                }
                            ]
                        });
                    }
                }).dxPopup("instance");
            }
            
            dataGridInstance.gridExpanded = false;

            dataGridInstance.option({
                // Filter builder 
                filterBuilder: {
                    allowHierarchicalFields: true
                },
                filterBuilderPopup: {
                    animation: null,
                    title: $translate.instant("G_FILTER"),
                    showTitle: true,
                    hideOnOutsideClick: true,
                    width: "50vw",
                    height: "50vh",
                    position: {
                        my: "right top",
                        at: "right bottom",
                        of: "#filterBuilderBtn",
                        boundary: window,
                        collision: "flipfit"
                    },
                    visible: false
                },
                filterSyncEnabled: true,
                // Toolbar actions
                toolbar: {
                    items: [
                        ... gridOptions.toolbarActions,
                        // Expand/Collapse group rows
                        {
                            widget: "dxButton",
                            options: {
                                icon:"expand",
                                onClick: function (event) {
                                    if (!dataGridInstance.gridExpanded) {
                                        dataGridInstance.gridExpanded = true;
                                        dataGridInstance.expandAll();
                                    }
                                    else {
                                        dataGridInstance.gridExpanded = false;
                                        dataGridInstance.collapseAll();
                                    }
    
                                    event.component.option("text", dataGridInstance.gridExpanded ? $translate.instant("G_COLLAPSE_ALL") : $translate.instant("G_EXPAND_ALL"));
                                },
                                text: dataGridInstance.gridExpanded ? $translate.instant("G_COLLAPSE_ALL") : $translate.instant("G_EXPAND_ALL")
                            },
                            locateInMenu: "auto",
                        },
                        // Reset grid group and column settings
                        {
                            widget: "dxButton",
                            options: {
                                icon:"revert",
                                onClick: function (event) {
                                    dataGridInstance.state(null)
                                },
                                text: $translate.instant("G_RESET_GRID")
                            }                        ,
                            locateInMenu: "always",
                        },
                        "groupPanel",
                        // Filter builder
                        {
                            widget: "dxButton",
                            options: {
                                icon: "filter",
                                text: $translate.instant("G_FILTER"),
                                elementAttr: { id: "filterBuilderBtn" },
                                onClick: function () {
                                    dataGridInstance.option("filterBuilderPopup.visible", true);
                                }
                            },
                            location: "after"
                        },
                        "columnChooserButton",
                        "exportButton",
                        "searchPanel",
                    ]
                },
                onSelectionChanged: function(e) {
                    var selectedCount = e.selectedRowKeys.length;
                    if (selectedCount > 0 && dataGridInstance.multiSelectPopup && gridOptions.getMultiSelectVisibilityFn()) {
                        dataGridInstance.multiSelectPopup.option("visible", true);
                        dxjQuery(".selected-count").text(`${selectedCount} ${$translate.instant('G_SELECTED')}`);
                    } else {
                        dataGridInstance.multiSelectPopup.option("visible", false);
                    }
                },
                onOptionChanged: function (args) { 
                    if (args.name === "filterValue") {
                        let showFilterPanel =  args.value && args.value.length > 0;
                        args.component.option("filterPanel.visible", showFilterPanel);
    
                        if (!showFilterPanel) dataGridInstance.clearSorting();
                    }
                }
            });

            return dataGridInstance;
        }
    }
})();
